module.exports = __webpack_public_path__ + "static/media/coming-soon.ad7eb5bd.png";